import { matchPath, useHistory, useLocation } from "react-router-dom";
import { Box, Divider, H5, Loading, Notification } from "orcs-design-system";

import PATHS, { url } from "src/consts/urlPaths";
import InboxList from "src/pages/WorkforceInbox/InboxList";
import { useInboxItems } from "src/pages/WorkforceInbox/useInboxItems";

/** Highlight the open item. `/inbox` with no id shows the landing, so none. */
export const selectedInboxKey = (pathname: string): string | null =>
  matchPath<{ itemId?: string }>(pathname, {
    path: PATHS.WORKFORCE_INBOX,
  })?.params.itemId ?? null;

const InboxContent = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { items, loading, error } = useInboxItems(true);
  const selectedKey = selectedInboxKey(pathname);
  const showLoading = loading && items.length === 0;
  const showError = !showLoading && Boolean(error) && items.length === 0;

  return (
    <Box>
      <H5 fontWeight="bold">Inbox</H5>
      <Box my="r">
        <Divider light />
      </Box>
      {showLoading ? <Loading /> : null}
      {showError ? (
        <Notification variant="error" closable={false}>
          The inbox could not be loaded.
        </Notification>
      ) : null}
      {!showLoading && !showError ? (
        <InboxList
          items={items}
          selectedKey={selectedKey}
          onSelect={(key) => {
            history.push(url(PATHS.WORKFORCE_INBOX, { itemId: key }));
          }}
        />
      ) : null}
    </Box>
  );
};

export default InboxContent;
